import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Button, Header, Icon, Modal } from 'semantic-ui-react';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import { useStore } from '../../app/stores/store';

function DeleteUser() {
  const {
    mediaAssetStore,
    userStore: { deleteUser },
    RolesAndPermissionsStore,
    commonStore,
  } = useStore();
  const { rolesRegistry, loadRoles } = RolesAndPermissionsStore;
  const handleDeleteUser = (id: string) => {
    deleteUser(id);
    mediaAssetStore.openDeleteUserModal(false, '', '');
  };
  useEffect(() => {
    if (rolesRegistry.size <= 1) loadRoles();
  }, [rolesRegistry.size, loadRoles]);
  return (
    <Modal
      onClose={() => (mediaAssetStore.mediaAsset.deleteUserModalOpen = false)}
      onOpen={() => (mediaAssetStore.mediaAsset.deleteUserModalOpen = true)}
      open={mediaAssetStore.mediaAsset.deleteUserModalOpen}
    >
      <Modal.Header style={{ color: 'red' }}>
        <Icon name="delete" />
        {
          (userLanguage[0].UserViewUserDelete?.UVUDL01 as any)?.[
            `${commonStore.language.key}`
          ]
        }
      </Modal.Header>
      <div>
        <Modal.Content>
          <Modal.Description>
            <Header
              style={{
                marginTop: '10px',
                marginLeft: '20px',
              }}
            >
              {
                (userLanguage[0].UserViewUserDelete?.UVUDL02 as any)?.[
                  `${commonStore.language.key}`
                ]
              }{' '}
              {mediaAssetStore.mediaAsset.userDetails.displayName}
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions
          style={{
            marginTop: '50px',
            marginBottom: '10px',
          }}
        >
          <Button
            color="black"
            onClick={() => mediaAssetStore.openDeleteUserModal(false, '', '')}
          >
            {
              (userLanguage[0].UserViewUserDelete?.UVUDB01 as any)?.[
                `${commonStore.language.key}`
              ]
            }
          </Button>
          <Button
            content={
              (userLanguage[0].UserViewUserDelete?.UVUDB02 as any)?.[
                `${commonStore.language.key}`
              ]
            } //"Yes"
            labelPosition="right"
            icon="checkmark"
            onClick={() =>
              handleDeleteUser(mediaAssetStore.mediaAsset.userDetails.id)
            }
            positive
          />
        </Modal.Actions>
      </div>
    </Modal>
  );
}

export default observer(DeleteUser);
